module.exports = __webpack_public_path__ + "img/bgc.6411c80a.png";